import { getScope } from "app/services/helpers/account-id";
import { hasPermissionTo } from "_metronic/layout/MenuConfig";

export function accessPermission(page) {
  if (!page) {
    return getScope() === "super admin";
  }
  return hasPermissionTo(page) || getScope() === "super admin";
}
